export const SERVICES = [
  {
    id: "paperless-polishing",
    title: "Paperless Concrete Polishing",
    subtitle: "5-Step Densification System",
    icon: "◆",
    image: "/3.png",
    short: "A 5-step system delivering dust-proof, shiny concrete surfaces using PVC pad grinding and liquid hardener treatment.",
    description:
      "After 10-15 days of curing, our expert team grinds with PVC pad #100, cleans thoroughly, applies liquid hardener, and gives the surface a one-time chemical super treatment. After at least 12 hours, PVC pad 200 is run wet. Dry runs of 400, 800, and 1500 PVC pads then produce a dust-proof, brilliantly shiny surface that lasts for years.",
    benefits: [
      "Dust-proof sealed surface",
      "One-time chemical treatment",
      "Long-lasting shine",
      "Low maintenance required",
      "Ideal for warehouses & factories",
    ],
    steps: [
      "Cure 10-15 days",
      "Grind with PVC 100",
      "Apply liquid hardener",
      "Chemical super treatment",
      "Polish: 200 → 400 → 800 → 1500",
    ],
    gallery: [
      "/1.png",
      "/2.png",
      "/3.png",
    ],
  },
  {
    id: "cream-finishing",
    title: "Cream Finishing & Polishing",
    subtitle: "7-Step Densification System",
    icon: "●",
    image: "/2.png",
    short: "A premium 7-step system producing a stain-resistant, dust-proof, shiny sealed surface for commercial spaces.",
    description:
      "After 15 days of curing, the surface is lightly cut and cleaned with 60 and 100 grade PVC, then a sufficient amount of chemical is applied. After 12 hours, wet run 100 or 200 grade PVC is performed, followed by thorough polishing with 200, 400, 800, or 1500 grade PVC.",
    benefits: [
      "Stain-resistant finish",
      "Premium cream aesthetic",
      "Sealed dust-free surface",
      "7-step quality assurance",
      "Suitable for commercial facilities",
    ],
    steps: [
      "Cure 15 days",
      "Cut & clean: PVC 60/100",
      "Apply chemical",
      "Wet run: PVC 100/200",
      "Polish: 200 → 400 → 800 → 1500",
    ],
    gallery: [
      "/30.png",
      "/31.png",
      "/3.png",
    ],
  },
  {
    id: "exposed-aggregate",
    title: "Exposed Aggregate (Retro Plate)",
    subtitle: "11-Step Polishing System",
    icon: "▲",
    image: "/30.png",
    short: "An 11-step system revealing stunning aggregate for a premium, high-gloss exposed concrete finish.",
    description:
      "After curing, heavy grinding is done with metal stones of 24, 36, 60, 120, and 200. Grinding continues with 60 and 100, followed by thorough cleaning and chemical application. After 12 hours, PVC stones of 200, 400, 800, 1500, and 3000 achieve a dust-resistant, stain-resistant, shiny, and stunning look.",
    benefits: [
      "Stunning exposed aggregate look",
      "11-step precision process",
      "Ultra-high gloss (3000 grade)",
      "Dust & stain resistant",
      "Unique decorative appearance",
    ],
    steps: [
      "Heavy grind: 24/36/60/120/200",
      "Refine: 60 & 100",
      "Deep clean",
      "Chemical application",
      "Polish: 200→400→800→1500→3000",
    ],
    gallery: [
      "/30.png",
      "/29.png",
      "/31.png",
    ],
  },
  {
    id: "old-floor-densification",
    title: "Old Floor Densification",
    subtitle: "Floor Restoration System",
    icon: "■",
    image: "/31.png",
    short: "Restore and extend the life of aging concrete floors with our proven densification and repair system.",
    description:
      "Repairing old floors with the appropriate compound, grinding, and applying liquid chemicals, then polishing with 100, 200, 400, and 800 stone can extend the life of dull, cracked surfaces significantly.",
    benefits: [
      "Extends floor lifespan",
      "Cost-effective restoration",
      "Dust-proof result",
      "Crack repair included",
      "Easy ongoing maintenance",
    ],
    steps: [
      "Surface diagnosis",
      "Compound repair & filling",
      "Grinding & cleaning",
      "Chemical application",
      "Polish: 100→200→400→800",
    ],
    gallery: [
      "/5.png",
      "/4.png",
      "/3.png",
    ],
  },
  {
    id: "joint-repair",
    title: "Construction Joint Repair",
    subtitle: "Sawed Joint Repair System",
    icon: "✦",
    image: "/9.png",
    short: "Permanent, professional repair of construction joints using the exclusive SK Concrete Floor system.",
    description:
      "After diagnosis and possibly slab stabilization, we carry out permanent and professional repairs using the exclusive SK Concrete Floor system. We use the HC Cosinus Slide Repair Joint system for jerk-free movement of MHE wheels.",
    benefits: [
      "Permanent joint repairs",
      "HC Cosinus Slide system",
      "Jerk-free MHE wheel movement",
      "Protects against future impacts",
      "Repairs docking bay transitions",
    ],
    steps: [
      "Joint diagnosis",
      "Slab stabilization",
      "HC Cosinus installation",
      "Transition zone repair",
      "Quality inspection",
    ],
    gallery: [
      "/35.png",
      "/34.png",
      "/9.png",
    ],
  },
  {
    id: "crack-repair",
    title: "Crack & Impact Damage Repair",
    subtitle: "Root-Cause Treatment",
    icon: "◉",
    image: "/34.png",
    short: "Root-cause crack diagnosis and permanent repair using Concrete Mender, resins, and cementitious products.",
    description:
      "We diagnose and solve crack problems by treating problems at the root, not superficially. Using Concrete Mender and resins and cementitious products, we treat cracks permanently with an almost indistinguishable appearance.",
    benefits: [
      "Root-cause crack treatment",
      "Near-invisible repair finish",
      "Concrete Mender technology",
      "Roadware impact repair",
      "Structural integrity restored",
    ],
    steps: [
      "Crack diagnosis",
      "Root cause analysis",
      "Concrete Mender injection",
      "Resin/cementitious fill",
      "Surface finish & polish",
    ],
    gallery: [
      "/11.png",
      "/34.png",
      "/9.png",
    ],
  },
  {
    id: "floor-maintenance",
    title: "Old Floor Maintenance",
    subtitle: "Scheduled Maintenance Programs",
    icon: "◈",
    image: "/6.png",
    short: "Comprehensive maintenance contracts including crack filling, polishing, patch repair, and screed overlays.",
    description:
      "Regular maintenance programs identify problems quickly and reduce remedial costs while improving facility throughput. We offer audits, scheduled annual maintenance contracts, and responsive maintenance.",
    benefits: [
      "Scheduled annual contracts",
      "Reduces remedial costs",
      "Improves facility efficiency",
      "Comprehensive audit service",
      "Responsive maintenance available",
    ],
    steps: [
      "Floor audit",
      "Maintenance plan creation",
      "Joint filler replacement",
      "Crack injection/filling",
      "Surface treatments & polishing",
    ],
    gallery: [
      "/30.png",
      "/29.png",
      "/6.png",
    ],
  },
  {
    id: "super-liquid-hardener",
    title: "Super Liquid Hardener",
    subtitle: "Chemical Densification Product",
    icon: "⬡",
    image: "/13.png",
    short: "A transparent water-based liquid that penetrates concrete, increasing density, hardness, and abrasion resistance by 65%.",
    description:
      "Super Liquid Hard is a transparent liquid water-based treatment that penetrates concrete and masonry, protecting, preserving, and strengthening them. Abrasion testing shows a treated floor will be 65% harder within the first 30 minutes.",
    benefits: [
      "65% harder in 30 minutes",
      "Moisture-free surface",
      "Abrasion resistant",
      "Low maintenance floor",
      "Dust-free sealed surface",
    ],
    steps: [
      "Surface preparation",
      "Apply Super Liquid Hard",
      "Allow 30-min penetration",
      "Surface continues hardening",
      "Routine scrub maintenance",
    ],
    gallery: [
      "/21.png",
      "/22.png",
      "/20.png",
    ],
  },
  {
    id: "safety-signs",
    title: "Safety Signs & Solutions",
    subtitle: "Complete Signage Systems",
    icon: "⚠",
    image: "/14.png",
    short: "Full range of industrial safety signs including epoxy markings, floor stickers, retro-reflective and radium sign boards.",
    description:
      "We provide a complete range of safety signs and solutions for industrial and commercial facilities including emergency signs, fire equipment signs, mandatory signs, prohibition signs, and hazard warning signs.",
    benefits: [
      "Complete safety compliance",
      "Epoxy floor markings",
      "Retro-reflective boards",
      "Custom safety signs",
      "Digital & vinyl options",
    ],
    steps: [
      "Safety audit",
      "Signage planning",
      "Custom design",
      "Professional installation",
      "Compliance verification",
    ],
    gallery: [
      "/17.png",
      "/15.png",
      "/16.png",
    ],
  },
  {
    id: "oxford-formula-contractor",
    title: "Oxford Formula Contractor",
    subtitle: "Advanced Densification Treatment",
    icon: "⬢",
    image: "/3.png",
    short: "Specialized contracting for high-performance floor hardening using an advanced densification formula for industrial concrete.",
    description:
      "Our Oxford Formula treatment is designed for industrial floors that demand higher abrasion resistance, reduced dusting, and longer service life. We assess slab condition, prepare the surface through grinding as required, apply the densification chemistry, and finish with a polishing sequence tailored to traffic type, MHE movement, and desired sheen level.",
    benefits: [
      "Lower dusting & easier cleaning",
      "Higher hardness & abrasion resistance",
      "Better stain resistance after sealing",
      "Improved floor life-cycle value",
      "Ideal for factories & warehouses",
    ],
    steps: [
      "Site inspection & slab assessment",
      "Surface preparation (grind/clean)",
      "Oxford Formula densifier application",
      "Curing / penetration time",
      "Polish & final finish (as required)",
    ],
    gallery: ["/1.png", "/2.png", "/3.png"],
  },
  {
    id: "retro-plate-formula-contractor",
    title: "Retro Plate Formula Contractor",
    subtitle: "Exposed Aggregate / Retro Plate Finish",
    icon: "△",
    image: "/30.png",
    short: "Contracting for retro plate (exposed aggregate) finishes with multi-step grinding and high-gloss polishing systems.",
    description:
      "For premium exposed aggregate floors, we execute a retro plate system with controlled heavy grinding to reveal the aggregate, followed by refinement, deep cleaning, chemical densification, and progressive polishing. The result is a decorative, durable surface that resists dust and stains and delivers a premium showroom-ready appearance.",
    benefits: [
      "Premium exposed aggregate look",
      "High-gloss finish options",
      "Dust & stain resistance",
      "Long-lasting decorative surface",
      "Suitable for showrooms & lobbies",
    ],
    steps: [
      "Aggregate exposure planning",
      "Heavy grind sequence",
      "Refinement grind & cleaning",
      "Densifier application",
      "Polish to desired gloss",
    ],
    gallery: ["/30.png", "/29.png", "/31.png"],
  },
  {
    id: "concrete-polishing-services",
    title: "Concrete Polishing Services",
    subtitle: "Industrial & Commercial Polishing",
    icon: "◆",
    image: "/2.png",
    short: "End-to-end concrete polishing for dust-free, high-shine floors in factories, warehouses, retail, and commercial spaces.",
    description:
      "Our concrete polishing services cover surface preparation, densification, and progressive polishing to achieve a dust-free, sealed, and durable finish. We tailor grit progression and chemistry based on floor age, traffic, and functional requirements such as MHE movement, reflectivity, and stain resistance.",
    benefits: [
      "Dust-free sealed surface",
      "Improves reflectivity & aesthetics",
      "Low-maintenance finish",
      "Better abrasion resistance",
      "Fast turnaround with clear process",
    ],
    steps: [
      "Condition assessment",
      "Grinding & leveling",
      "Densifier/hardener application",
      "Progressive polishing",
      "Final sealing & handover",
    ],
    gallery: ["/30.png", "/31.png", "/3.png"],
  },
  {
    id: "dust-free-flooring-manufacturers",
    title: "Dust Free Flooring Manufacturers",
    subtitle: "Dust-Proof Floor Systems",
    icon: "✦",
    image: "/31.png",
    short: "Dust-free flooring solutions delivered via densification and sealing systems for industrial concrete floors.",
    description:
      "While concrete floors are built on-site, the dust-free performance comes from the right system design and execution. We deliver dust-proof floor outcomes using surface preparation, densifiers (silicate-based), and polishing/sealing methods that minimize dusting and keep floors cleaner for longer.",
    benefits: [
      "Reduces concrete dusting",
      "Cleaner facility environment",
      "Improves floor durability",
      "Compatible with heavy traffic",
      "Lower long-term maintenance",
    ],
    steps: [
      "Dusting root-cause diagnosis",
      "Surface prep & cleanup",
      "Densifier application",
      "Polish/seal to requirement",
      "Maintenance guidance",
    ],
    gallery: ["/5.png", "/4.png", "/3.png"],
  },
  {
    id: "floor-polish-dealers",
    title: "Floor Polish Dealers",
    subtitle: "Polishing Consumables & Guidance",
    icon: "◈",
    image: "/6.png",
    short: "Supply guidance and service execution for floor polishing consumables, pads, and compatible chemicals for concrete floors.",
    description:
      "Choosing the right polishing pads, grit sequence, and compatible hardeners matters for performance and finish. We support projects by recommending the correct consumables and, more importantly, executing the polishing system end-to-end so the floor achieves the intended dust-proof and shine outcome.",
    benefits: [
      "Correct pad & grit selection",
      "Compatible chemical recommendations",
      "Better finish consistency",
      "Reduced rework risk",
      "Professional execution available",
    ],
    steps: [
      "Requirement & site review",
      "Consumables/system selection",
      "Surface preparation",
      "Polishing execution",
      "Quality checks & handover",
    ],
    gallery: ["/30.png", "/29.png", "/6.png"],
  },
  {
    id: "flooring-repair-and-services",
    title: "Flooring Repair & Services",
    subtitle: "Concrete Floor Repair & Rehab",
    icon: "■",
    image: "/34.png",
    short: "Repairs for cracks, joints, spalling, and worn areas plus densification/polishing services to restore floor performance.",
    description:
      "We provide concrete floor repair and rehabilitation services including crack treatment, joint repairs, patching, and surface restoration. After repairs, we apply densification and polishing to strengthen the surface, reduce dusting, and improve usability for industrial operations.",
    benefits: [
      "Crack & joint repairs",
      "Restores worn or spalled areas",
      "Improves safety & movement",
      "Reduces dusting after rehab",
      "Extends floor life",
    ],
    steps: [
      "Site diagnosis & marking",
      "Repair method selection",
      "Execution (repair/patch/joint)",
      "Densification & polishing",
      "Final inspection & handover",
    ],
    gallery: ["/11.png", "/34.png", "/9.png"],
  },
  {
    id: "industrial-densi-polishing-services",
    title: "Industrial Densi Polishing Services",
    subtitle: "Densify + Polish for Heavy Traffic",
    icon: "⬡",
    image: "/13.png",
    short: "Industrial densification and polishing services to produce dust-proof, abrasion-resistant floors for MHE operations.",
    description:
      "Industrial Densi Polishing combines chemical densification with a controlled polishing process to create a hardened surface that resists dusting and wear. We choose the chemistry (silicate-based) and grit progression based on slab age, traffic intensity, and desired reflectivity.",
    benefits: [
      "Abrasion-resistant hardened surface",
      "Dust-proof performance",
      "Better MHE wheel movement",
      "Lower maintenance",
      "Improved reflectivity",
    ],
    steps: [
      "Surface assessment",
      "Grinding & prep",
      "Densifier/hardener application",
      "Progressive polishing",
      "Quality checks & handover",
    ],
    gallery: ["/21.png", "/22.png", "/20.png"],
  },
  {
    id: "industrial-polished-concrete-flooring-contractors",
    title: "Industrial Polished Concrete Flooring Contractors",
    subtitle: "End-to-End Industrial Execution",
    icon: "▲",
    image: "/3.png",
    short: "Contractor services for industrial polished concrete flooring, from preparation and repair to densification and final polish.",
    description:
      "As industrial flooring contractors, we manage the full process: diagnostics, surface repairs as needed, grinding, densification, and polishing. The goal is a long-life floor with minimal dusting, strong abrasion resistance, and a professional finish suitable for warehouses, plants, and logistics hubs.",
    benefits: [
      "Single-team execution",
      "Works for new and old floors",
      "Dust reduction & durability",
      "Traffic-ready finish",
      "Clear process and handover",
    ],
    steps: [
      "Site survey & plan",
      "Repairs (if required)",
      "Grinding & densification",
      "Polishing to spec",
      "Final walkthrough",
    ],
    gallery: ["/1.png", "/2.png", "/3.png"],
  },
  {
    id: "lithium-silicate-manufacturers",
    title: "Lithium Silicate Manufacturers",
    subtitle: "Lithium Densifier Solutions",
    icon: "⚗",
    image: "/13.png",
    short: "Lithium silicate-based densification solutions applied for faster reaction, harder surfaces, and reduced dusting on concrete.",
    description:
      "Lithium silicate densifiers are widely used to harden concrete surfaces with excellent penetration and reaction control. We implement lithium-based densification as part of a floor treatment system, helping industrial facilities reduce dusting and improve abrasion resistance and finish quality.",
    benefits: [
      "Hardens concrete surface",
      "Helps reduce dusting",
      "Improves abrasion resistance",
      "Supports polishing outcomes",
      "Industrial-grade performance",
    ],
    steps: [
      "Surface preparation",
      "Lithium densifier application",
      "Curing/penetration time",
      "Polish/seal (as required)",
      "Maintenance guidance",
    ],
    gallery: ["/21.png", "/22.png", "/20.png"],
  },
  {
    id: "polished-concrete-flooring-contractors",
    title: "Polished Concrete Flooring Contractors",
    subtitle: "Commercial & Industrial Floors",
    icon: "●",
    image: "/2.png",
    short: "Polished concrete flooring contractor services for clean, durable, and high-shine surfaces with low maintenance.",
    description:
      "We deliver polished concrete flooring systems suited to both commercial and industrial settings. Depending on required finish, we apply densifiers, polish through the right grit progression, and optionally seal to improve stain resistance while preserving a premium look.",
    benefits: [
      "Premium polished finish",
      "Low maintenance",
      "Durable and long-lasting",
      "Better reflectivity",
      "Dust reduction via densification",
    ],
    steps: [
      "Site inspection",
      "Grinding & refinement",
      "Densifier application",
      "Polishing sequence",
      "Handover & care tips",
    ],
    gallery: ["/30.png", "/31.png", "/3.png"],
  },
  {
    id: "sodium-silicate-liquid-manufacturers",
    title: "Sodium Silicate Liquid Manufacturers",
    subtitle: "Sodium-Based Densifier Systems",
    icon: "⚗",
    image: "/13.png",
    short: "Sodium silicate densification systems implemented to strengthen concrete surfaces and reduce dusting for industrial use.",
    description:
      "Sodium silicate liquids can be used as part of densification treatments for concrete floors. We apply sodium-based densifiers where appropriate and follow up with polishing/sealing methods to improve surface hardness, reduce dusting, and support long-term performance.",
    benefits: [
      "Improves surface hardness",
      "Reduces dusting",
      "Supports polishing finishes",
      "Cost-effective chemistry option",
      "Industrial suitability",
    ],
    steps: [
      "Surface preparation",
      "Sodium silicate application",
      "Penetration & cure",
      "Polish/seal as needed",
      "Final inspection",
    ],
    gallery: ["/21.png", "/22.png", "/20.png"],
  },
  {
    id: "industrial-densi-polishing-services-industrial",
    title: "Industrial Densi Polishing Services (Industrial)",
    subtitle: "High-Load Warehouse Finishes",
    icon: "◉",
    image: "/31.png",
    short: "A high-load densification + polishing package focused on logistics hubs, distribution floors, and heavy MHE zones.",
    description:
      "This industrial-focused densi polishing package is optimized for heavy-load areas such as logistics hubs and distribution centers. We emphasize joint and crack readiness, deeper densification, and a polishing level that balances grip, durability, and ease of cleaning under continuous operations.",
    benefits: [
      "Optimized for heavy MHE traffic",
      "Improved wear resistance",
      "Dust reduction and easier cleaning",
      "Better floor usability",
      "Clear maintenance recommendations",
    ],
    steps: [
      "Traffic/load assessment",
      "Repairs & surface readiness",
      "Densification treatment",
      "Polish to operational requirement",
      "Operational handover checklist",
    ],
    gallery: ["/5.png", "/4.png", "/3.png"],
  },
  {
    id: "dust-proof-floor-contractor",
    title: "Dust Proof Floor Contractor",
    subtitle: "Dust-Proof Sealed Floor Solutions",
    icon: "✦",
    image: "/3.png",
    short: "Dust-proof floor contractor services for industrial concrete — densification, sealing, and polishing to stop dusting.",
    description:
      "If your concrete floor is generating dust, the solution is a systematic treatment: diagnose the cause, prepare the surface, apply the right densifier/hardener chemistry, and finish with polishing/sealing. We deliver dust-proof outcomes that reduce housekeeping effort and improve facility hygiene.",
    benefits: [
      "Stops floor dusting",
      "Cleaner operations",
      "Longer floor life",
      "Improves abrasion resistance",
      "Warehouse & factory ready",
    ],
    steps: [
      "Dusting diagnosis",
      "Grinding/cleaning preparation",
      "Densifier application",
      "Polish/seal finish",
      "Maintenance plan",
    ],
    gallery: ["/1.png", "/2.png", "/3.png"],
  },
];
